import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Popup from "./Popup";
import Heading from "./Heading";
import Input from "./Input";
import "../sass/Login.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faGoogle } from "@fortawesome/free-brands-svg-icons";
import { LoginContext } from "./context/LoginContext";

const Login = ({ title }) => {
  const { addName } = useContext(LoginContext);
  const [name, setName] = useState();
  const navigate = useNavigate();
  return (
    <Popup>
      <Heading type="H2">{title}</Heading>
      <Input
        onChange={(e) => setName(e.target.value)}
        type="email"
        label="Email"
      />
      <Input type="text" label="Password" />
      <div className="popupFooter">
        <Link className="btn btn-link" to="/forgot_password">
          Forgot Password?
        </Link>
        <span>
          <Link className="btn btn-link" to="/">
            Cancel
          </Link>
          <button
            onClick={() => {
              addName(name);
              navigate(-2);
            }}
            className="btn btn-primary"
          >
            Login
          </button>
        </span>
      </div>
      <hr className="seperator" />
      <div className="socialLogin">
        <button className="btn">
          <FontAwesomeIcon icon={faFacebookF} /> {title} with Facebook
        </button>
        <button className="btn">
          <FontAwesomeIcon icon={faGoogle} /> {title} with Google
        </button>
      </div>
    </Popup>
  );
};

export default Login;
